import { Link } from '@tanstack/react-router'

export function SiteLogo() {
	return (
		<Link className='logo-row' to='/'>
			<span className='logo-mark'>
				<svg fill='none' height='18' viewBox='0 0 24 24' width='18'>
					<title>SeaLedger</title>
					<path
						d='M3 17c2-1.5 3.5-1.5 4.5 0 1 1.5 2.5 1.5 4.5 0 2-1.5 3.5-1.5 4.5 0 1 1.5 2.5 1.5 4.5 0'
						stroke='oklch(20% 0.04 80)'
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth='2'
					/>
					<path
						d='M12 3l1.6 3.4L17 8l-3.4 1.6L12 13l-1.6-3.4L7 8l3.4-1.6L12 3z'
						fill='oklch(20% 0.04 80)'
					/>
				</svg>
			</span>
			<span className='logo-text'>
				Sea<em>Ledger</em>
			</span>
		</Link>
	)
}
